<!--
 * @Author: yefan
 * @Date: 2025-11-05 13:31:25
 * @Description: 实名认证审核查看（微信小程序）
-->
<template>
	<div class="app-real">
		<el-row>
			<el-form ref="realForm" :model="realForm" label-width="120px" class="form-item-bottom0" size="small">
				<el-col :span="12" class="mt10">
					<el-form-item>证件类型：身份证</el-form-item>
				</el-col>
				<el-col :span="12" class="mt10">
					<el-form-item>证件编号：{{ realForm.idCard }}</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>姓名：{{ realForm.sname }}</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>手机号：{{ realForm.phone }}</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>审核结果：<span class="green">认证通过</span></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>审核时间：{{ rowData.updateDate }}</el-form-item>
				</el-col>
			</el-form>
		</el-row>
	</div>
</template>
<script>
import { getRecordDetail } from 'api/modules/audit'
export default {
	props: {
		rowData: {
			type: Object,
			deafault: () => {
				return {}
			}
		}
	},
	data() {
		return {
			realForm: {},
		};
	},
	created() {
		this.getMsgInfo()
	},
	methods: {
		// 获取信息
		getMsgInfo() {
			getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				this.realForm = res.data;
			});
		}
	}
}
</script>
<style lang="less" scoped>
.app-real {
	.green {
		color: green;
	}
}
</style>
